import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { SCREENS } from '@cloudsuite/mosaic-shared/styles/breakpoints.js'


export const cseMenu = {
  groupGap: css`var(--cse-menu-group-gap, ${csSpacing.spacing04})`,
}

export const style: CSSResult = css`
  .cse-menu {
    display: flex;
    flex-direction: column;
    gap: ${cseMenu.groupGap};
  }

  .cse-menu.layout-inline {
    flex-direction: row;
    overflow-x: auto;
    align-items: center;
    --cse-menu-child-layout: column;
  }

  @media (max-width: ${SCREENS.medium}) {
    .cse-menu.layout-mobile-inline {
      flex-direction: row;
      overflow-x: auto;
      align-items: center;
      --cse-menu-child-layout: column;
    }

    .cse-menu.layout-mobile-vertical {
      flex-direction: column;
      align-items: normal;
      --cse-menu-child-layout: row;
    }
  }
`
